import { Box, SlideFade, useColorModeValue } from '@chakra-ui/react';
import { PageContainer } from '@/components/PageContainer';
import { Footer } from '@/components/Footer';
import { SiteNav } from '@/components/Navbar/SiteNav';
import { PUBLIC_PAGE_CONTENT_PT } from '@/components/Navbar/siteNavLayout';
import { useAuthModal } from '@/hooks';
import { RulesIntroSections } from './RulesIntroSections';
import { RulesTournamentSection } from './RulesTournamentSection';
import { RulesExamplesSection } from './RulesExamplesSection';

export default function RulesPage() {
  const { openRegisterModal } = useAuthModal();
  const sectionBorderColor = useColorModeValue('blackAlpha.200', 'whiteAlpha.200');

  return (
    <SlideFade in>
      <PageContainer>
        <SiteNav />
        <Box as='main' width='full' pb={10}>
          <Box maxW='4xl' mx='auto' px={{ base: 4, sm: 6, md: 8 }} pt={PUBLIC_PAGE_CONTENT_PT}>
            <RulesIntroSections onClickCTA={openRegisterModal} />
          </Box>

          <Box maxW='4xl' mx='auto' px={{ base: 4, sm: 6, md: 8 }} pt={{ base: 6, md: 10 }}>
            <RulesTournamentSection />
          </Box>

          <Box
            maxW='min(1220px, 100%)'
            mx='auto'
            px={{ base: 4, md: 8, xl: 12 }}
            pt={{ base: 10, md: 14 }}
            mt={{ base: 6, md: 10 }}
            borderTopWidth='1px'
            borderColor={sectionBorderColor}
          >
            <RulesExamplesSection />
          </Box>
        </Box>
        <Footer />
      </PageContainer>
    </SlideFade>
  );
}
